const onlyEnglishLetters = (str: string) => /^[A-Za-z]+$/.test(str);

export const getCompanyFirstLetter = (company: string) => {
  const letter = company.charAt(0).toLowerCase();
  return onlyEnglishLetters(letter) ? letter : "default";
};
